<script setup lang="ts">
  import CheckMarkIcon from '@/shared/assets/icons/CheckMarkIcon.svg';
  import { ColoredButton } from '@/shared/ui';

  const props = defineProps<{
    isSaveButtonActive: boolean;
    isLoading: boolean;
  }>();

  defineEmits(['cancel', 'save']);
</script>

<template>
  <div class="w-auto py-8 px-6 flex justify-end items-center font-medium gap-6">
    <ColoredButton
      outlined
      color="gray-03"
      text="Cancelar"
      @click="$emit('cancel')"
    />
    <ColoredButton
      text="Salvar"
      :icon="CheckMarkIcon"
      icon-alt="Icone de check"
      :loading="isLoading"
      :disabled="props.isLoading || !props.isSaveButtonActive"
      @click="$emit('save')"
    />
  </div>
</template>
